import { useState } from "react";
import { faqs } from "@/mocks/chigua";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="bg-primary-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14">
        <div>
          <p className="text-sm font-bold uppercase tracking-wide text-primary-600">常见问题 FAQ</p>
          <h2 className="mt-2 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
            关于吃瓜大赛，常被问到的几件事
          </h2>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            从晋级规则到更新频率，最受关注的疑问都为你一次性讲清楚。没找到答案？欢迎到底部留下你的问题。
          </p>
          <div className="mt-6 hidden flex-wrap gap-2 lg:flex">
            {["晋级规则", "赛程更新", "战报节奏", "虚构内容"].map((k) => (
              <span key={k} className="rounded-full border border-primary-200 bg-background-50 px-3 py-1 text-xs text-primary-700">
                {k}
              </span>
            ))}
          </div>
        </div>

        <div className="divide-y divide-primary-200/70 rounded-3xl bg-background-50 px-5 shadow-sm md:px-7">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div key={f.q}>
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 py-5 text-left"
                >
                  <h3 className="flex items-start gap-3 font-heading text-base leading-snug text-foreground-950 md:text-lg">
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                        open ? "bg-primary-500 text-background-50" : "bg-primary-100 text-primary-700"
                      }`}
                    >
                      <i
                        className={`text-xs transition-transform duration-300 ${
                          open ? "ri-subtract-line" : "ri-add-line"
                        }`}
                        aria-hidden="true"
                      ></i>
                    </span>
                    {f.q}
                  </h3>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] pb-5 opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}